<p-accordion [value]="0">
  <p-accordion-panel [value]="0">
    <p-accordion-header>
      <span class="flex align-items-center gap-2 w-full">
        <span class="font-bold white-space-nowrap">
          AutoPay & Paperless Setup
        </span>
        @if (autopayEnrollementValid) {
          <p-badge [value]="languageService.getTranslation('COMPLETE')" severity="success" class="ml-auto mr-2" />
        } @else {
          <p-badge [value]="languageService.getTranslation('INCOMPLETE')" severity="danger"
            class="ml-auto mr-2" />
        }
      </span>
    </p-accordion-header>
    <p-accordion-content>
      <div class="flex flex-column pt-3 sara-accordion-background" [formGroup]="autopayPaperlessPaymentForm">
        <div class="flex flex-column justify-content-between p-3 gap-3 accordion-view">
          <div class="flex justify-content-between align-items-center gap-3 cursor-pointer" (click)="toggleAccordion()">
            <div class="flex justify-content-between">
              <i [ngClass]="{'pi-chevron-down': !flowTypeAccordion, 'pi-chevron-up': flowTypeAccordion}"
              class="pi mr-2" style="font-size: 1rem"></i>
              <span class="text-lg font-semibold">
                <app-translate key="ATT_RESIDENTIAL_SATELLITE"></app-translate>
              </span>
            </div>
          </div>
          <div class="flex flex-column gap-2 text-sm font-normal">
            <div class="flex align-items-center gap-1 font-italic">
              @if (!autopayPaperlessPaymentForm.get('autopayEnrollment')?.value) {
                <i class="pi pi-bundle-red-x" style="width: 24px; height: 24px;"></i>
                <span><app-translate key="AUTOPAY"></app-translate> - <span class="font-bold"><app-translate
              key="DECLINED"></app-translate></span></span>
            } @else if (autopayEnrollementValid) {
              <i class="pi pi-bundle-green-check-small" style="width: 24px; height: 24px;"></i>
              <span><app-translate key="AUTOPAY"></app-translate> - <span class="font-bold"><app-translate
            key="ENROLLED"></app-translate></span></span>
          } @else {
            <i class="pi pi-bundle-exclamation-yellow" style="width: 24px; height: 24px;"></i>
            <span><app-translate key="AUTOPAY"></app-translate> - <span class="font-bold"><app-translate
          key="ENROLLED"></app-translate></span></span>
        }
      </div>
    </div>
  </div>

  @if (flowTypeAccordion) {
    <div class="flex flex-column p-3 pt-1 accordion-content">
      <hr class="section-divider">
      <div class="flex flex-column justify-content-between gap-3">
        <div class="flex flex-column mt-4">
          <div class="flex flex-column">
            <div class="flex justify-content-between gap-1">
              <div class="flex gap-2">
                <span class="text-base font-semibold"><app-translate
                key="AUTOPAY_ENROLLMENT"></app-translate>
              </span>
              <i #autopayInfoIcon class="pi pi-info-circle cursor-pointer text-primary"
              (click)="autopayDetails.toggle($event, autopayInfoIcon)"></i>
              <p-popover #autopayDetails [style]="{'width': '360px', 'border-radius': '12px'}"
                appendTo="body" my="top left" at="bottom left">
                <div class="p-3">
                  <div class="flex justify-content-between align-items-center mb-2">
                    <h3 class="m-0"><app-translate key="AUTOPAY_DETAILS"></app-translate></h3>
                    <i class="pi pi-times cursor-pointer" (click)="autopayDetails.hide()"></i>
                  </div>
                  <p class="m-0">
                    <app-translate key="AUTOPAY_DETAILS_DESCRIPTION"></app-translate>
                  </p>
                </div>
              </p-popover>
            </div>
            <p-toggleswitch formControlName="autopayEnrollment"
            (ngModelChange)="autopayEnrollmentChange($event)"></p-toggleswitch>
          </div>
          <div class="flex gap-2 pt-2">
            <p-checkbox formControlName="autopayEnrollmentTerms" [binary]="true"
              [ngClass]="{'disabled-content': !autopayPaperlessPaymentForm.get('autopayEnrollment')?.value }"
              [inputId]="orderFlowType + 'autopayterms'"
              [disabled]="!autopayPaperlessPaymentForm.get('autopayEnrollment')?.value">
            </p-checkbox>
            <label for="{{orderFlowType}}autopayterms" class="font-normal text-sm"
              [ngClass]="{'disabled-content': !autopayPaperlessPaymentForm.get('autopayEnrollment')?.value }">
              <app-translate key="RESIDENTIAL_SATELLITE_AGREE_AUTOPAY_TERMS"></app-translate>
            </label>
          </div>
          <div class="flex gap-2 pt-2">
            <p-checkbox formControlName="paperlessEnrollmentTerms" [binary]="true"
              [ngClass]="{'disabled-content': !autopayPaperlessPaymentForm.get('autopayEnrollment')?.value }"
              [inputId]="orderFlowType + 'paperlessEnrollmentTerms'"
              [disabled]="!autopayPaperlessPaymentForm.get('autopayEnrollment')?.value">
            </p-checkbox>
            <label for="{{orderFlowType}}paperlessEnrollmentTerms" class="font-normal text-sm"
              [ngClass]="{'disabled-content': !autopayPaperlessPaymentForm.get('autopayEnrollment')?.value }">
              <app-translate key="RESIDENTIAL_SATELLITE_AGREE_PAPERLESS_BILLING"></app-translate>
            </label>
          </div>
        </div>
      </div>
    </div>
    <hr class="section-divider">
    @if (autopayPaperlessPaymentForm.get('autopayEnrollment')?.value && autopayPaperlessPaymentForm.get('autopayEnrollmentTerms')?.value) {
      <div class="flex flex-column mt-5"
        >
        <div class="flex flex-column gap-3 mb-3">
          <div class="flex flex-column gap-1">
            <div class="flex align-items-center gap-1">
              <span class="text-base font-semibold"><app-translate
              key="RESIDENTIAL_SATELLITE_AUTOPAY_INFORMATION"></app-translate></span>
            </div>
          </div>
          @if (paymentAllowAch) {
            <div class="flex flex-column gap-3">
              <div class="flex align-items-center gap-2">
                <span class="font-light text-sm"><app-translate key="PAY_WITH_ACH"></app-translate></span>
                <p-toggleswitch formControlName="payWithAch"></p-toggleswitch>
              </div>
              <div class="font-light text-sm">
                <app-translate key="LAST_NAME_MATCHING_REQUIREMENT"></app-translate>
              </div>
            </div>
          }
        </div>
        @if (!autopayPaperlessPaymentForm.get('payWithAch')?.value) {
          <div class="flex flex-column">
            @if (todaysChargesApplicable) {
              <div class="mb-4 flex gap-2 pl-2 align-items-center">
                <p-checkbox formControlName="samePaymentMethod"
                  [ngClass]="{'disabled-content': !todaysChargesApplicable}" [binary]="true"
                  [inputId]="orderFlowType + 'samePaymentMethod'" [disabled]="!todaysChargesApplicable">
                </p-checkbox>
                <label for="{{orderFlowType}}samePaymentMethod" class="font-normal text-sm"
                  [ngClass]="{'disabled-content': !todaysChargesApplicable}">
                  <app-translate key="USE_SAME_PAYMENT_INFO"></app-translate>
                </label>
              </div>
            }
            @if (!autopayPaperlessPaymentForm.get('samePaymentMethod')?.value) {
              <div class="flex">
                <app-credit-card-billing [customerName]="customerName" #autopayCreditCardBilling></app-credit-card-billing>
              </div>
            }
          </div>
        }
        @if (autopayPaperlessPaymentForm.get('payWithAch')?.value) {
          <div class="flex flex-column gap-2">
            <div class="flex">
              <app-ach-billing #autopayAchBilling></app-ach-billing>
            </div>
          </div>
        }
      </div>
    }
  </div>
}
</div>
</p-accordion-content>
</p-accordion-panel>
</p-accordion>